export const PHONE_NUMBER = '+1 (727) 598-7543';
export const EMAIL = 'borysenko.info@gmail.com';
export const LOCATION = 'Florida, USA';
